import { render, staticRenderFns } from "./TempletTabStyle.vue?vue&type=template&id=714fea2e&scoped=true&"
import script from "./TempletTabStyle.vue?vue&type=script&lang=js&"
export * from "./TempletTabStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714fea2e",
  null
  
)

export default component.exports